<template>
    <div
        :class="$attrs.class"
        class="rounded-full bg-black/30 backdrop-blur-lg w-8 h-6 flex items-center justify-center"
    >
        <NuxtImg  v-if="iconSrc" :src="iconSrc" width="32" height="24" :alt="iconAlt"/>
        <div v-else class="size-8 bg-gray-800 rounded-full flex items-center justify-center">
            <Icon name="tabler:exclamation-circle" size="16px" class="text-white" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { TPlanNames } from "~/types/global/user.type";

interface IProps {
    planName: TPlanNames;
}

const props = defineProps<IProps>();
const iconSrc = computed((): string => {
    let iconsSrc: Record<TPlanNames, string> = {
        basic: "/svg/acl-icons/basic-icon.svg",
        standard: "/svg/acl-icons/standard-icon.svg",
        pro: "/svg/acl-icons/pro-icon.svg",
        "pro-plus": "/svg/acl-icons/pro-plus-icon.svg",
        enterprise: "/svg/acl-icons/enterprise-icon.svg",
        custom: "",
        "sub-account": "/svg/subAccount.png",
    };
    return iconsSrc[props.planName] ? iconsSrc[props.planName] : "";
});

const iconAlt = computed((): string => {
    let iconsAlt: Record<TPlanNames, string> = {
        basic: "basic-picing",
        standard: "standard-pricing",
        pro: "pro-pricing",
        "pro-plus": "proplus-pricing",
        enterprise: "enterprise-pricing",
        custom: "custom-pricing",
        "sub-account": "sub-pricing",
    };
    return iconsAlt[props.planName] ? iconsAlt[props.planName] : "";
});
</script>
